import { Head } from "@inertiajs/react";
import { t } from "@travily/i18n";
import {
  foundingMemberCreatorPath,
  foundingMemberCreatorPausePath,
  foundingMemberCreatorStagePath,
} from "@travily/routes";
import type FoundingMemberCreatorFamilyExperience from "@travily/types/pages/FoundingMemberCreatorFamilyExperience";
import { useCreatorTopBarActions } from "@/lib/wizard/use-creator-top-bar-actions";
import { useWizardForm } from "@/lib/wizard/use-wizard-form";
import { ExperienceStepView } from "./show.view";

type FormData = {
  family_profile: {
    worldschooling_experience: string | null;
  };
};

const FIELD = "family_profile.worldschooling_experience";

const ExperienceStep = ({ stage_index, stage_order, family_profile }: FoundingMemberCreatorFamilyExperience) => {
  const { form, validate, fieldError, currentStage, totalStages, onBack, onPrimary, primaryPending, onPause } =
    useWizardForm<FormData>({
      routes: {
        stageUrl: (stage) => foundingMemberCreatorStagePath("family", stage),
        entryUrl: foundingMemberCreatorPath(),
        pauseUrl: foundingMemberCreatorPausePath(),
      },
      stageName: "experience",
      stageIndex: stage_index,
      stageOrder: stage_order,
      initialData: {
        family_profile: { worldschooling_experience: family_profile.worldschooling_experience ?? null },
      },
    });

  const error = fieldError(FIELD);

  const topBarActions = useCreatorTopBarActions({ onPause });

  return (
    <>
      <Head title={t("web.founding_members.creator.steps.family.experience.show.meta_title")}>
        <meta
          name="description"
          content={t("web.founding_members.creator.steps.family.experience.show.meta_description")}
        />
      </Head>
      <ExperienceStepView
        currentStage={currentStage}
        totalStages={totalStages}
        onBack={onBack}
        topBarActions={topBarActions}
        isPending={primaryPending}
        value={form.data.family_profile.worldschooling_experience}
        error={error}
        onChange={(value) => {
          form.setData(FIELD, value);
          validate(FIELD);
        }}
        onContinue={onPrimary}
      />
    </>
  );
};

export default ExperienceStep;
